import { useTranslation } from "react-i18next";
import './DepositPopUpComponent.scss';
import { useSelector } from "react-redux";

const DepositRequestPopUp = (props: any) => {
    const { t } = useTranslation("common");
    const {  redemptionRightDataRedux } = useSelector(
        (state: any) => state.DashboardReducer
      );

    const {  userFunds } = useSelector(
    (state: any) => state.DashboardReducer
    );

    return (
        <div className="DepositRequestPopUp">
            <h2 id="dialogTitle" className="mb-4">{t('depositPopUp.depositTitle')}</h2>
            
            {/* {console.log("items",props.items)} */}
            {props.items.map((item: any, i: number) => {
                if(item?.title?.length > 0){
                let redemption = redemptionRightDataRedux.filter((itemRed:any)=> item.fundCode === itemRed.fundCode && itemRed.isBalanceTypePension === 1 )
                // console.log(redemption);
                //  redemption.filter
                return item.interactiveFormPath || item.msg !== null   ?
                    <div key={i} className="box-pop d-flex justify-content-space-between align-items-center mt-3">
                        <div>
                            {item.title && <h3>{item.title[0]?.fundLabel}</h3>}
                            {item.interactiveFormPath && redemption[0]?.totalRedemption ? 
                            <p >{`${t('depositPopUp.depositSubtitle')} - ${Math.trunc(redemption[0]?.totalRedemption).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ₪`}</p>:null}
                            {item.msg !== null && item.interactiveFormPath == null  ? 
                            <p className="msg">{item.msg}</p>:null}
                        </div>
                        {item.interactiveFormPath ? 
                        <button 
                         title="מעבר לאתר חיצוני"
                         className="white-pdf-btn white-pdf-text"
                         onClick={() => window.open(encodeURI(item.interactiveFormPath), "_blank")}>{t('depositPopUp.depositBtn')}</button> : null}
                    </div> : null}
            })}
        </div>
    )

}
export default DepositRequestPopUp;

